<template>
  <b-card class="shadow mb-4" no-body
          :id="collapse_state?record_type+'-records':'not-'+record_type+'-records'">
    <b-card-header v-b-toggle="'records-'+record_type+'-collapse'" class="collapse-header">
      <b-badge v-if="records" variant="secondary"
               class="mr-2 align-text-top" pill>{{ records.length }}
      </b-badge>
      <h5 class="d-inline">{{ record_type }} {{ $tc('system.record', 2) }}</h5>
      <netvs-icon class="collapse-icon" icon="collapse"></netvs-icon>
    </b-card-header>
    <b-card-body body-class="p-0">
      <b-collapse :id="'records-'+record_type+'-collapse'" :visible="collapse_state" @input="sync_collapse">
        <FilterInput v-model="filter" class="mx-3"/>
        <Paginator :current-page="current_page" :per-page="per_page" @current-page="current_page = $event"
                   @per-page="per_page = $event" :total-rows="filtered_and_sorted_records.length"
                   v-if="loaded && filtered_and_sorted_records.length > 0"/>

        <b-table-simple responsive class="table b-table" v-if="collapse_state">
          <b-thead>
            <b-tr>
              <b-th>
                <!--b-checkbox :indeterminate="toggleAllIsUnkn(record_type)" v-model="toggle_all[record_type]" @input="toggleAll(record_type)"
                            :unchecked-value="false"></b-checkbox!-->
                <div class="text-center">
                              <span :id="record_type + '_bulk'">
                              <b-button :disabled="!canEnableBulkAction(record_type)"
                                        @click="bulkDelete(record_type)" variant="outline-danger">
                                <netvs-icon icon="delete"></netvs-icon>
                              </b-button>
                              </span>
                </div>
                <b-tooltip :target="record_type+'_bulk'" triggers="hover"
                           variant="danger" placement="right">
                  {{ $t('components.dns_record_type_card.delete_selected_records') }}
                </b-tooltip>
              </b-th>
              <b-th class="record-table-header"
                    :aria-sort="(sort_by === 'fqdn')?sort_dir:'none'"
                    @click="changeSort('fqdn')">
                <div>{{ $t('system.fqdn') }}</div>
              </b-th>
              <b-th class="record-table-header">{{ $t('system.more_information') }}</b-th>
              <b-th class="record-table-header"
                    :aria-sort="(sort_by === 'fqdn_description')?sort_dir:'none'"
                    @click="changeSort('fqdn_description')">{{ $t('system.fqdn_description') }}
              </b-th>
              <b-th class="record-table-header"
                    :aria-sort="(sort_by === 'data')?sort_dir:'none'"
                    @click="changeSort('data')">{{ $t('system.record_data') }}
              </b-th>
              <b-th class="record-table-header"
                    :aria-sort="(sort_by === 'ttl')?sort_dir:'none'"
                    @click="changeSort('ttl')">
                {{ $t('system.ttl') }}
              </b-th>
              <b-th>
                <b-btn-group class="d-flex" role="group">
                  <b-button variant="outline-success"
                            :id="'button-create-record-' + record_type" @click="createRecord(record_type)"
                            v-if="user_possible_record_types.includes(record_type)">
                    <netvs-icon icon="create"></netvs-icon>
                  </b-button>
                  <b-button variant="outline-primary"
                            :id="'button-export-record-' + record_type" @click="exportCSV()">
                    <netvs-icon icon="export"></netvs-icon>
                  </b-button>
                </b-btn-group>
                <b-tooltip :target="'button-create-record-' + record_type" triggers="hover"
                           variant="success" placement="left">
                  {{ $t('components.dns_record_type_card.create_new_record') }}
                </b-tooltip>
                <b-tooltip :target="'button-export-record-' + record_type" triggers="hover"
                           variant="primary" placement="bottom">
                  {{ $t('components.dns_record_type_card.csv_export') }}
                </b-tooltip>
              </b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <!-- eslint-disable vue/no-v-for-template-key !-->
            <template
                v-for="(item, item_index) in fs_sliced_records">
              <template
                  v-if="record_type === 'A' && sort_by === 'data'  && !filter && item.data in blocks_before_by_ip && ((item_index-1 < 0 && fs_sliced_records.length !== 1) || fs_sliced_records[item_index-1]?.data !== item.data)">
                <BCDFreeAddressBlock :key="'block_upper_' + item.data + '_' + block_index"
                                     v-for="(block,block_index) in reverseIfDesc(blocks_before_by_ip[item.data])"
                                     :create_item_func="createRecord" :block="block"
                                     :item="item" :index="block_index"></BCDFreeAddressBlock>
              </template>
              <b-tr :key="item.fqdn + '_' + item.data">
                <b-td>
                  <b-checkbox class="text-center"
                              v-model="records_checked[record_type + '_' + item.fqdn + '_' + item.data]"></b-checkbox>
                </b-td>
                <b-td>
                  <b-link :to="`/dnsvs/fqdns/${item.fqdn}`">{{ item.fqdn }}</b-link>
                  <b-badge v-if="item.host_is_nws" variant="primary"
                           :href="$store.state.sysinfo.netdb_admin_base + `/~netadmin/natvs/user/wrapper.cgi/${bcd.name}/0/${bcd.name}/0/nat_index.html`"
                           :title="$t('components.dns_record_type_card.host_has_natvs_entry')">{{ $t('system.natvs') }}
                  </b-badge>
                </b-td>
                <b-td>
                  <RecordInfo :item="item"></RecordInfo>
                </b-td>
                <b-td>
                  <span class="fqdn-description">{{ item.fqdn_description }}</span>
                </b-td>
                <b-td>
                  <RRDataView :item="item" :subnets="subnets"></RRDataView>
                  <b-badge v-if="item.data in reserved_addrs_by_ip" variant="warning"
                           :title="$t('components.dns_record_type_card.address_is_reserved')">
                    {{ $t('components.dns_record_type_card.reserved') }}
                  </b-badge>
                  <b-badge href="#" @click="createRecord('AAAA', item.data, item.fqdn)"
                           v-if="bcd_has_v4 && bcd_has_v6 && record_type === 'A' && !fqdnHasAAAA(item.fqdn)"
                           variant="danger">{{ $t('components.dns_record_type_card.no_AAAA_record') }}
                  </b-badge>
                </b-td>
                <b-td>
                  <template v-if="item.ttl != null">{{ item.ttl }}{{ $t('system.second_time_s') }}</template>
                  <span v-else :title="$t('components.dns_record_type_card.inherited_from_zone')"
                        class="text-muted">{{ item.ttl_zone_default }}{{ $t('system.second_time_s') }}</span>
                  <span v-if="item.ttl_reset_days"
                        class="text-danger"><br/>{{
                      $tc('components.dns_record_type_card.reset_in_days', item.ttl_reset_days, {days: item.ttl_reset_days})
                    }}</span>
                  <span v-if="item.ttl_reset_date" class="text-danger"><br/>{{
                      $t('components.dns_record_type_card.reset_on_day', {day: item.ttl_reset_date})
                    }}</span>
                </b-td>
                <b-td>
                  <b-button-group>
                    <b-dropdown boundary="window"
                                :id="'button-edit-record-' +  item.fqdn + '_' + record_type + '_' + item.data"
                                @click="editRecord(item)" split variant="outline-primary">
                      <template #button-content>
                        <netvs-icon icon="edit"></netvs-icon>
                      </template>
                      <b-dropdown-item :disabled="!(item.fqdn in fqdns)"
                                       @click="edit_fqdn(fqdns[item.fqdn])">
                        {{ $t('components.dns_record_type_card.edit_fqdn') }}
                      </b-dropdown-item>
                    </b-dropdown>
                    <RecordDeleteButton :record="item"/>
                  </b-button-group>
                  <b-tooltip
                      :target="'button-edit-record-' +  item.fqdn + '_' + record_type + '_' + item.data"
                      triggers="hover"
                      variant="primary" placement="left">
                    {{ $t('components.dns_record_type_card.edit_record') }}
                  </b-tooltip>
                </b-td>
              </b-tr>
              <template
                  v-if="record_type === 'A' && !filter && sort_by === 'data' && fs_sliced_records.length - 1 === item_index">
                <BCDFreeAddressBlock :key="'block_lower_' + item.data + '_' + j"
                                     v-for="(blk,j) in reverseIfDesc(after_end_blocks)"
                                     :create_item_func="createRecord" :block="blk"
                                     :item="item" :index="j"/>
              </template>
            </template>
          </b-tbody>
        </b-table-simple>
        <Paginator :current-page="current_page" :per-page="per_page" @current-page="current_page = $event"
                   @per-page="per_page = $event" :total-rows="filtered_and_sorted_records.length"
                   v-if="loaded && filtered_and_sorted_records.length > 0"/>
      </b-collapse>
    </b-card-body>
    <CreateDNSRecord
        v-if="user_possible_record_types.includes(record_type)"
        :modal_id="`create_record-${record_type}`"
        :fixed_record_type="'type' in db_editor_presets?db_editor_presets.type:record_type"
        :loose_data="'data' in db_editor_presets?db_editor_presets.data:null"
        :fixed_fqdn="'fqdn' in db_editor_presets?db_editor_presets.fqdn:null"
    />

    <DBEditor :presets="db_editor_presets" :input_reducer="create_record_reducer"
              :modal_id="`update_record-${record_type}`"
              :object_title="object_title"
              :object_function="db_editor_function" object_fq_name="dns.record" :old_data="db_editor_old_data"
              :non_optionals_order="['fqdn', 'type', 'data', 'fqdn_description', 'target_is_singleton', 'target_is_reverse_unique']">
    </DBEditor>
  </b-card>
</template>

<script>
import FilterInput from '@/components/FilterInput'
import ipaddress from '@/util/ipaddress'
import RRDataView from '@/components/RRDataView'
import RecordInfo from '@/components/RecordInfo'
import BCDFreeAddressBlock from '@/components/BCDFreeAddressBlock'
import DBEditor from '@/components/db-editor/APIObjectDBEditor.vue'
import CreateDNSRecord from '@/db-editors/CreateDNSRecord.vue'
import RecordDeleteButton from '@/components/RecordDeleteButton.vue'
import Paginator from '@/components/Paginator.vue'

export default {
  name: 'DNSRecordTypeCard',
  components: {
    Paginator,
    RecordDeleteButton,
    CreateDNSRecord,
    DBEditor,
    BCDFreeAddressBlock,
    RecordInfo,
    RRDataView,
    FilterInput
  },
  data() {
    return {
      filter: '',
      current_page: 1,
      per_page: 50,
      sort_dir: 'ascending',
      sort_by: ['A', 'AAAA'].includes(this.record_type) ? 'data' : 'fqdn',
      records_checked: [],
      blocks_before_by_ip: {},
      after_end_blocks: [],
      asc_all_blocks: [],
      db_editor_presets: {},
      db_editor_old_data: {},
      create_record_reducer: undefined,
      object_title: null,
      db_editor_function: 'create',
    }
  },
  props: {
    record_type: {
      required: true
    },
    records: {
      required: true
    },
    loaded: {
      required: true
    },
    reserved_addrs_by_ip: {
      required: true,
      type: Object
    },
    full_edit_fqdn_reducer: {
      required: true,
      type: Object
    },
    record_types_by_name: {
      required: true,
      type: Object
    },
    records_by_fqdn: {
      required: true,
      type: Object
    },
    collapse_state: {
      required: true
    },
    edit_fqdn: {
      required: true,
      type: Function
    },
    user_possible_record_types: {
      required: true,
      type: Array
    },
    subnets: {
      required: true,
      type: Array
    },
    fqdns: {
      required: true
    },
    bcd_has_v4: {
      required: false,
      default() {
        return false
      }
    },
    bcd_has_v6: {
      required: false,
      default() {
        return false
      }
    },
    bcd: {
      required: true,
      type: Object
    },
  },
  mounted() {
    this.calculate_block_lists()
  },
  methods: {
    deleteRecord: RecordDeleteButton.methods.deleteRecord,
    canEnableBulkAction(rec_type) {
      let check_count = 0
      for (const b of this.records) {
        if (this.records_checked[rec_type + '_' + b.fqdn + '_' + b.data]) {
          check_count++
        }
      }
      return check_count > 0
    },
    filterFunc(item, term) {
      if (typeof term === 'string') {
        term = term.toLowerCase()
      }
      for (const v of Object.values(item)) {
        if (typeof v === 'string') {
          if (v.toLowerCase().includes(term)) {
            return true
          }
        }
      }
      return false
    },
    changeSort: function (col) {
      if (this.sort_by === col) {
        if (this.sort_dir === 'ascending') {
          this.sort_dir = 'descending'
        } else {
          this.sort_dir = 'ascending'
        }
      } else {
        this.sort_by = col
        this.sort_dir = 'ascending'
      }
    },
    exportCSV: function () {
      const items = this.filter ? this.records : this.fs_sliced_records

      let content = '"FQDN","FQDN_Description","Data","TTL"\n'
      items.forEach((item) => {
        content += `"${item.fqdn ? item.fqdn : ''}",`
        content += `"${item.fqdn_description ? item.fqdn_description : ''}",`
        content += `"${item.data ? item.data : ''}",`
        content += `"${item.ttl != null ? item.ttl : ''}"`
        content += '\n'
      })

      const blob = new Blob([content], {type: 'text/csv;charset=utf-8;'})

      const link = document.createElement('a')
      link.download = 'dns-export-' + this.bcd.name + '-' + this.record_type + '.csv'
      link.href = URL.createObjectURL(blob)
      link.click()
      URL.revokeObjectURL(link.href)
    },
    bulkDelete() {
      for (const b of this.records) {
        if (this.records_checked[this.record_type + '_' + b.fqdn + '_' + b.data]) {
          this.deleteRecord(b, false)
          this.$root.$set(this.records_checked, this.record_type + '_' + b.fqdn + '_' + b.data, false)
        }
      }
    },
    reverseIfDesc(arr) {
      return (this.sort_dir === 'ascending') ? arr : [...arr].reverse()
    },
    sync_collapse(visible) {
      this.$emit('update:collapse_state', visible)
    },
    fqdnHasAAAA(fqdn) {
      for (const r of this.records_by_fqdn[fqdn]) {
        if (r.type === 'AAAA') {
          return true
        }
      }
      return false
    },
    calculate_block_lists() {
      // Precalculate free/reserved address blocks before each record and after the last record
      if (this.record_type !== 'A') {
        return
      }
      const blocks_before_by_ip = {}
      const after_end_blocks = []
      const ordered_blocks = []
      const v4_subnets = this.subnets.filter(subnet => subnet.type === '4').map(subnet => {
        const size = ipaddress.ip_num_addr(subnet.cidr)
        const net_int = ipaddress.ip_to_int(subnet.cidr.split('/')[0])
        // network and broadcast address are not usable for subnets larger than /31 (RFC 3021)
        return {
          subnet: subnet,
          net_int: net_int,
          first_usable: net_int + (size > 2 ? 1 : 0),
          last_usable: net_int + size - 1 - (size > 2 ? 1 : 0)
        }
      }).sort((a, b) => a.net_int - b.net_int)
      const record_ints = [...new Set(this.records.filter(r => r.type === 'A').map(r => ipaddress.ip_to_int(r.data)))].sort((a, b) => a - b)
      let ri = 0
      let prev_ip = null
      for (const sn of v4_subnets) {
        // records outside any v4 subnet: no free blocks around them
        while (ri < record_ints.length && record_ints[ri] < sn.first_usable) {
          prev_ip = record_ints[ri]
          ri++
        }
        // records inside this subnet: free space between the previous record and this one
        // is rendered before the record
        while (ri < record_ints.length && record_ints[ri] <= sn.last_usable) {
          const cur = record_ints[ri]
          const start = Math.max(sn.first_usable, prev_ip === null ? sn.first_usable : prev_ip + 1)
          if (start <= cur - 1) {
            const segs = this.build_containing_blocks(start, cur - 1)
            blocks_before_by_ip[ipaddress.int_to_ip(cur)] = segs
            ordered_blocks.push(...segs)
          }
          prev_ip = cur
          ri++
        }
        // free space after the last record of this subnet (or the whole subnet if empty)
        const trail_start = Math.max(sn.first_usable, prev_ip === null ? sn.first_usable : prev_ip + 1)
        if (trail_start <= sn.last_usable) {
          const segs = this.build_containing_blocks(trail_start, sn.last_usable)
          after_end_blocks.push(...segs)
          ordered_blocks.push(...segs)
        }
      }
      this.blocks_before_by_ip = blocks_before_by_ip
      this.after_end_blocks = after_end_blocks
      this.asc_all_blocks = ordered_blocks
    },
    build_containing_blocks(start_int, end_int) {
      // build free/reserved segments for the inclusive integer range [start_int, end_int]
      const blocks = []
      let last_chg_ip = start_int
      let last_was_reserved = ipaddress.int_to_ip(start_int) in this.reserved_addrs_by_ip
      for (let i = start_int + 1; i <= end_int; i++) {
        const is_reserved = ipaddress.int_to_ip(i) in this.reserved_addrs_by_ip
        if (is_reserved !== last_was_reserved) {
          blocks.push({
            first: ipaddress.int_to_ip(last_chg_ip),
            type: last_was_reserved ? 'reserved' : 'free',
            space: i - last_chg_ip
          })
          last_was_reserved = is_reserved
          last_chg_ip = i
        }
      }
      blocks.push({
        first: ipaddress.int_to_ip(last_chg_ip),
        type: last_was_reserved ? 'reserved' : 'free',
        space: end_int + 1 - last_chg_ip
      })
      return blocks
    },
    editRecord: function (item) {
      this.db_editor_function = 'update'
      this.db_editor_old_data = item
      this.db_editor_presets = item
      this.object_title = item.type + '-' + this.$t('views.dnsvs.bcd_records.record_to_fqdn') + ' ' + item.fqdn
      this.create_record_reducer = {}
      this.create_record_reducer.fqdn = false
      this.create_record_reducer.type = false
      this.$root.$emit('bv::show::modal', `update_record-${this.record_type}`)
    },
    createRecord: function (record_type, data, fqdn) {
      this.db_editor_function = 'create'
      this.db_editor_presets = {
        type: record_type,
        data: data,
      }
      if (fqdn) {
        window.console.debug('Limiting fqdn to', fqdn)
        this.db_editor_presets.fqdn = fqdn
      }
      if (record_type === 'AAAA') {
        let sub = null
        let multi = false
        this.subnets.forEach((item) => {
          if (item.type === '6') {
            if (sub !== null) {
              multi = true
            }
            sub = item
          }
        })
        if (sub !== null && !multi) {
          const split = sub.cidr.split('/')
          this.db_editor_presets.data = split[0]
          if (split[1] === '64' && data) {
            this.db_editor_presets.data += data
          }
        } else if (multi) {
          this.db_editor_presets.data = ''
        }
      }
      if (record_type === 'A' && (!data)) {
        for (const b of this.asc_all_blocks) {
          if (b.type === 'free') {
            this.db_editor_presets.data = b.first
            break
          }
        }
      }
      this.$root.$emit('bv::show::modal', `create_record-${this.record_type}`)
    }
  },
  computed: {
    filtered_records() {
      return this.records.filter(x => this.filterFunc(x, this.filter))
    },
    filtered_and_sorted_records() {
      let recs = [...this.filtered_records]
      if (this.filter) {
        recs = recs.filter(x => this.filterFunc(x, this.filter))
      }
      recs = recs.sort((a, b) => {
        if (this.record_type === 'A' && this.sort_by === 'data') {
          return ipaddress.ip_to_int(a.data) - ipaddress.ip_to_int(b.data)
        } else if (this.record_type === 'AAAA' && this.sort_by === 'data') {
          return ipaddress.compare_ipv6(a.data, b.data)
        } else if (this.sort_by === 'ttl') {
          return (a.ttl || a.ttl_zone_default) - (b.ttl || b.ttl_zone_default)
        } else {
          return (a[this.sort_by] || '').localeCompare((b[this.sort_by] || ''))
        }
      })
      if (this.sort_dir === 'descending') {
        return recs.reverse()
      }
      return recs
    },
    fs_sliced_records() {
      if (this.per_page <= 0) return this.filtered_and_sorted_records
      return this.filtered_and_sorted_records.slice(this.per_page * (this.current_page - 1), this.per_page * this.current_page)
    },
  },
  watch: {
    filter() {
      this.current_page = 1
    },
  }
}
</script>

<style scoped>
.list-group-item.active {
  color: white !important;
}

.collapse-icon {
  display: inline;
  vertical-align: center;
  float: right;

  transition: transform;
  transition-duration: 250ms;
}

.not-collapsed > .collapse-icon {
  transform: rotate(-180deg);
}

.bottom-space {
  padding-bottom: 200px;
}

.squish-enter-active, .squish-leave-active {
  transition: width 250ms, padding-left 250ms, padding-right 250ms;
}

.squish-enter, .squish-leave-to {
  width: 0;
  padding-right: 0;
  padding-left: 0;
}

.collapse-header {
  z-index: 69;
}

.record-table-header {
  vertical-align: middle;
}

.fqdn-description {
  display: inline-block;
  max-width: 350px;
}

</style>
